import React from "react";
import {
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  ListItemSecondaryAction,
  Typography,
} from "@mui/material";
import { useApp } from "context";
import { Enums, Helpers, Routes, Store } from "utils";
import { IClinic } from "interfaces";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";

type Props = {
  clinic: IClinic;
  isPinned?: boolean;
};

export const Clinic = (props: Props) => {
  const { locale, t, theme } = useApp();

  const isClinic = Store.sessionStorage.isClinic();

  const hasChat =
    props.clinic.lastAppointment ||
    props.clinic.clinicId === Store.sessionStorage.get().clinicId ||
    isClinic;

  return (
    <>
      <ListItem disableGutters disablePadding dense>
        <ListItemText
          primary={
            <Typography
              sx={{
                fontSize: theme.font.md,
                color: theme.palette.font.color,
              }}
            >
              {props.clinic.username}
            </Typography>
          }
          secondary={
            <Typography
              sx={{
                fontSize: theme.font.sm,
                color: theme.palette.font.accent,
              }}
            >
              {props.clinic.lastAppointment
                ? Helpers.interpolate(
                    t.message.appointment.related_appointment,
                    {
                      date: Helpers.toRelativeDate(
                        props.clinic.lastAppointment.scheduledTime,
                        t.relative_date,
                        locale,
                        true
                      ),
                    }
                  )
                : t.message.appointment.not_visited}
            </Typography>
          }
        />
        {hasChat && (
          <ListItemSecondaryAction>
            <IconButton
              sx={{ color: theme.palette.font.color }}
              href={
                isClinic
                  ? Helpers.interpolateURL(Routes.clinic.chat, {
                      id: props.clinic.clinicId,
                      userType: Enums.EnumUser.Clinic,
                    })
                  : Helpers.interpolateURL(Routes.patient.chat, {
                      id: props.clinic.clinicId,
                    })
              }
            >
              <QuestionAnswerIcon />
            </IconButton>
          </ListItemSecondaryAction>
        )}
      </ListItem>
    </>
  );
};
